import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { filterVisibleTasks } from './Row';

const useVisibleTasks = tasks => {
  const { is_superuser: isSuperUser } = useSelector(
    ({ common }) => common.userInfo
  );

  return useMemo(
    () => filterVisibleTasks(tasks, isSuperUser),
    [tasks, isSuperUser]
  );
};

export default useVisibleTasks;
